/* eslint-disable */
// Tiny DOMPurify wrapper so any HTML/SVG strings coming from LL_DATA
// (logo overrides, custom icon SVG, etc.) are sanitized before being
// rendered via dangerouslySetInnerHTML.

import DOMPurify from 'dompurify';

// SVG is allowed because LL_DATA stores inline SVG strings for logos /
// custom icons (this is the original source behaviour we are migrating).
const SVG_TAGS = [
  'svg','g','path','rect','circle','ellipse','line','polyline','polygon',
  'text','tspan','defs','linearGradient','radialGradient','stop','mask',
  'clipPath','use','symbol','title','desc','filter','feGaussianBlur',
  'feOffset','feMerge','feMergeNode','feColorMatrix','feFlood',
  'feComposite','feBlend','animate','animateTransform',
];
const SVG_ATTRS = [
  'viewBox','xmlns','xmlns:xlink','fill','stroke','stroke-width',
  'stroke-linecap','stroke-linejoin','stroke-miterlimit','stroke-opacity',
  'fill-opacity','d','x','y','x1','y1','x2','y2','cx','cy','r','rx','ry',
  'points','width','height','transform','opacity','clip-path','mask',
  'gradientUnits','gradientTransform','offset','stop-color','stop-opacity',
  'preserveAspectRatio','class','style','id','href','xlink:href',
];

export function sanitizeHTML(input) {
  if (typeof input !== 'string') return '';
  return DOMPurify.sanitize(input, {
    ADD_TAGS: SVG_TAGS,
    ADD_ATTR: SVG_ATTRS,
    USE_PROFILES: { html: true, svg: true, svgFilters: true },
    FORBID_TAGS: ['script', 'iframe', 'object', 'embed', 'form'],
    FORBID_ATTR: ['onerror', 'onload', 'onclick', 'onmouseover', 'onfocus'],
  });
}

if (typeof window !== 'undefined') {
  window.LL_sanitizeHTML = sanitizeHTML;
}
